const global = window

// Support de conditions d'affichages
inputs.behavior.api = function (data, name, niceName, type, input, inputParent, inputWindow) {
    const apiForm = input.closest('[data-api]')
    const apiFormData = apiForm.data('data')

    if (
        apiForm.length > 0
        && (!apiForm.data('trigger') || apiForm.data('trigger') == data.name)
    ) {
        const method = apiForm.data('method') ? apiForm.data('method') : 'PUT'
        const parentApiCall = function (event) {
            event.stopPropagation()
            if (input.data('noQ') || input.data('hold') || global.noQ) {
                return false
            }
            console.log(input);
            const url = apiForm.data('api')
            const method = apiForm.data('method') ? apiForm.data('method') : 'PUT'
            if (apiForm.data('q')) clearTimeout(apiForm.data('q'))
            
            let apiDeferred = apiForm.data('apiDeferred')
            if (!apiDeferred || apiDeferred.state() !== 'pending') {
                apiDeferred = $.Deferred()
                apiForm.data('apiDeferred', apiDeferred)
            }

            const q = setTimeout(() => {
                if (formValidationProcess(apiForm)) {
                    if (!url) {
                        console.error('No API URL provided')
                        apiDeferred.reject()
                        return false
                    }
                    callAPI(method, url, getFormData(apiForm, true), function (data) {
                        if (event && event.type === 'click') {
                            inputWindow.find('input, select, textarea').filter(':visible').val('').change();
                            if (apiFormData && apiFormData.ajax) {
                                apiFormData.reload();
                            }
                            if (apiForm.data('redirect')) {
                                let redirect = apiForm.data('redirect');
                                redirect = redirect.replace(/{{(.*?)}}/g, (match, p1) => {
                                    return data[p1] !== undefined ? data[p1] : match; // Remplace par la valeur de data, sinon laisse le match original
                                });
                                if (parent && parent.loadPageUrl) {
                                    parent.loadPageUrl(redirect);
                                }
                                else {
                                    loadPageUrl(redirect);
                                }
                            }
                            if (parent && parent.closeWindow) parent.closeWindow();
                        }
                        input.trigger('api-success', [data, method, url]);
                        apiForm.trigger('api-success', [data, method, url]);
                        if (apiFormData && apiFormData.ajax) {
                            apiFormData.reload();
                        }

                        // Auto-rechargement si l'élément définit data-reload dans ses paramètres API
                        const reloadUrl = apiForm.data('reload') || apiForm.attr('data-reload');
                        if (reloadUrl) {
                            const pf = apiForm.closest('.window, body');
                            const parentFormData = (typeof getFormData === 'function') ? getFormData(pf) : {};
                            const rowFormData = (typeof getFormData === 'function') ? getFormData(apiForm, true) : {};
                            const requestData = Object.assign({}, parentFormData, rowFormData);

                            if (apiForm.data('value') && !requestData.value) {
                                requestData.value = apiForm.data('value');
                            }
                            if (!requestData.contrat && requestData.id) {
                                requestData.contrat = requestData.id;
                            }
                            if (!requestData.contrat && apiForm.data('value')) {
                                requestData.contrat = apiForm.data('value');
                            }

                            const table = apiForm.closest('table');
                            if (table.length) {
                                const hasFournitures = table.find('th[data-name="total_fournitures"], th[data-name="fournitures_realisees"]').length > 0 ? 1 : 0;
                                requestData.hasFournitures = hasFournitures;
                            }

                            const rowId = apiForm.attr('id') || '';
                            if (rowId.indexOf('inter') !== -1) {
                                requestData.isIntercie = 1;
                            }

                            ajaxCall({
                                url: reloadUrl,
                                method: 'POST',
                                data: requestData,
                                dataType: 'html',
                                callback(response) {
                                    apiForm.html(response);
                                    if (typeof onContentLoad === 'function') {
                                        onContentLoad(apiForm);
                                    }
                                    if (typeof registerInputStack === 'function') {
                                        registerInputStack();
                                    }
                                    const table = apiForm.closest('table');
                                    if (table.length) {
                                        table.trigger('row:reloaded', [apiForm]);
                                    }
                                }
                            });
                        }

                        apiDeferred.resolve(data)
                    }, function(data) {
                        if (event && event.type === 'click') {
                            if (data.responseJSON && data.responseJSON.error) alert(data.responseJSON.error)
                            else alert('Une erreur est survenue.');
                        }
                        input.trigger('api-error', [data, method, url]);
                        apiForm.trigger('api-error', [data, method, url]);
                        apiDeferred.reject(data)
                    });
                } else {
                    apiDeferred.reject()
                }
            }, 100)
            apiForm.data('q', q)
        }

        if (method == 'PUT') {
            input.change(function(event) {
                const inputTarget = $(event.target);
                const inputData = inputTarget.data() || {};
                const fieldName = (inputData && inputData.name) || inputTarget.attr('name') || data.name || niceName;
                let currentVal = getFieldData(fieldName, inputParent);
                if (currentVal === undefined) {
                    currentVal = getFieldData(fieldName, apiForm);
                }
                if (currentVal === undefined) {
                    currentVal = inputTarget.val();
                }

                if (data.valueLast != currentVal) {
                    data.valueLast = currentVal;
                    inputTarget.data('valueLast', currentVal);
                    parentApiCall(event);
                }
            })
        }
        else if (method == 'POST') {
            input.change(function(event) {
                event.stopPropagation()
            })
        }

        if (type == 'btn' && apiForm.data('trigger') == data.name) {
            input.click(parentApiCall)
        }
    }
    return data
}
